import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_category_to_addon_item_link_RowClass } from '../../../dbschema';

export class CategoryToAddonItemLinkContainerModel extends BaseContainerModel {

  bl_fi_category_to_addon_item_link: bl_fi_category_to_addon_item_link_RowClass = new bl_fi_category_to_addon_item_link_RowClass();
}
